"use strict";const e=require("react/jsx-runtime"),n=require("react"),s=require("./GenericButton.js"),r=t=>e.jsx(s,{useAsLink:!0,...t}),o=n.memo(r);module.exports=o;
//# sourceMappingURL=LinkButton.js.map
